<template>
  <div>
    <div v-if="!Permit.isFreeEdition() &&
      Permit.currentTenant() &&
      Permit.currentTenant().charge.availableDays <= 15
      " class="center" style="background: red; color: #fff; padding: 2px 0">
      系统还有
      {{ Permit.currentTenant().charge.availableDays }}
      天到期，请联系客服续费，以免影响使用
    </div>
    <div v-if="Permit.isFreeEdition() &&
      Permit.currentTenant() &&
      Permit.currentTenant().charge.availableDays > 0 &&
      Permit.currentTenant().charge.availableDays <= 15
      " class="center" style="background: red; color: #fff; padding: 2px 0">
      系统还有
      {{ Permit.currentTenant().charge.availableDays }}
      天到期，请联系客服续费，以免影响使用
    </div>
    <div class="wrapper">
      <breadcrumb :crumbs="['主工作台']">
        <div class="center mgb5 blue" v-if="Permit.currentUser().admin">
          <el-badge is-dot class="dot-tip blue" v-if="!systemUpdateReadDF">
            <a @click="clickReadSystemUpdate">
              {{ $t("menu.sysLogs") }}<small>({{ sysLog.createAt }})</small>
            </a>
          </el-badge>
          <a @click="clickReadSystemUpdate" class="gray" v-else>
            {{ $t("menu.sysLogs") }}<small>({{ sysLog.createAt }})</small>
          </a>
        </div>
      </breadcrumb>
      <el-row :gutter="10">
        <el-col :span="18" v-if="!Permit.isFreeEdition()">
          <user-sales v-if="Permit.extendModels().includes('oms') &&
      Permit.canActionsChargeEdition('omsUserSales')
      "></user-sales>
          <shop-sales v-if="Permit.extendModels().includes('oms') &&
      Permit.canActionsChargeEdition('omsShopSales')
      "></shop-sales>
          <whole-sales v-if="Permit.extendModels().includes('oms') &&
      Permit.canActionsChargeEdition('omsWholeSales')
      "></whole-sales>
          <el-row :gutter="10">
            <el-col :span="12">
              <order-thead v-if="Permit.extendModels().includes('oms') &&
      Permit.canActionsChargeEdition('omsOrderThead')
      "></order-thead>
            </el-col>
            <el-col :span="12">
              <order-track v-if="Permit.extendModels().includes('oms') &&
      Permit.canActionsChargeEdition('omsOrderTrack')
      "></order-track>
            </el-col>
          </el-row>
          <purchase-supplier-sta v-if="Permit.extendModels().includes('pms') &&
      Permit.canActionsChargeEdition('pmsSuplierPurchases')
      "></purchase-supplier-sta>
          <delivery-count v-if="(Permit.extendModels().includes('lmsE') ||
        Permit.extendModels().includes('lmsC')) &&
      Permit.canActionsChargeEdition('lmsDeliveryCount')
      "></delivery-count>
          <el-row :gutter="10">
            <el-col :span="12">
              <purchase-track v-if="Permit.extendModels().includes('pms') &&
      Permit.canActionsChargeEdition('pmsPurchaseTrack')
      "></purchase-track>
            </el-col>
            <el-col :span="12">
              <material-wH v-if="Permit.extendModels().includes('mms') &&
      Permit.canActionsChargeEdition('mmsMaterialWH')
      "></material-wH>
            </el-col>
          </el-row>
          <material-on-way v-if="Permit.extendModels().includes('mms') &&
      Permit.canActionsChargeEdition('mmsMaterialOnWay')
      "></material-on-way>
          <mes-statistic v-if="Permit.extendModels().includes('mes') &&
      Permit.canActionsChargeEdition('mesStatistic')
      "></mes-statistic>
          <mes-track v-if="Permit.extendModels().includes('mes') &&
      Permit.canActionsChargeEdition('mesTrack')
      "></mes-track>
          <el-row :gutter="10">
            <el-col :span="12" v-if="Permit.extendModels().includes('mes') &&
      Permit.canActionsChargeEdition('mesDispersion')
      ">
              <mes-dispersion></mes-dispersion>
            </el-col>
            <el-col :span="12" v-if="Permit.extendModels().includes('mes') &&
      Permit.canActionsChargeEdition('mesProduce')
      ">
              <div style="background: #fff; padding: 10px" class="mgb10">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="扫描派发" name="start">
                    <mes-produce></mes-produce>
                  </el-tab-pane>
                  <el-tab-pane label="生产结束" name="end">
                    <mes-scan-end></mes-scan-end>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-col>
          </el-row>
          <warehouse v-if="Permit.extendModels().includes('wms') &&
      Permit.canActionsChargeEdition('wmsWarehouse')
      "></warehouse>
        </el-col>
        <el-col :span="18" v-if="Permit.isFreeEdition()">
          <prompt-free></prompt-free>
        </el-col>
        <el-col :span="6">
          <inventory-search v-if="Permit.extendModels().includes('wms') &&
      Permit.canActionsChargeEdition('wmsInventorySearch')
      "></inventory-search>
          <material-search v-if="Permit.extendModels().includes('mms') &&
      Permit.canActionsChargeEdition('mmsProductInquiryMaterial')
      "></material-search>
          <el-button v-if="Permit.extendModels().includes('wms') &&
      Permit.extendModels().includes('rms') &&
      Permit.canActionsChargeEdition('wmsInventorySearchSchedule')
      " type="primary" style="width: 100%" class="mgb10"
            @click="$router.push('/normal/wms/inventory-search-schedule')">
            {{ $t("action.inventorySearchSchedule") }}
          </el-button>
          <div>
            <el-button v-if="Permit.extendModels().includes('mes') &&
      Permit.currentTenant().config.mesSchedule == true &&
      Permit.canActionsChargeEdition('mesWorkOrderDistribute')
      " type="primary" style="width: 100%" class="mgb10"
              @click="$router.push('/normal/mes/schedule-analyse')">{{ $t("action.searchMesSchedule") }}</el-button>
          </div>
          <div>
            <el-button v-if="Permit.extendModels().includes('mes') &&
      Permit.currentTenant().config.mesSchedule == true &&
      Permit.canActionsChargeEdition('mesCalcExpectHandOver')
      " type="primary" style="width: 100%" class="mgb10"
              @click="$router.push('/normal/mes/calc-expect-handOver')">{{ $t("action.calcExpectHandOver")
              }}</el-button>
          </div>
          <tasks></tasks>
          <message></message>
        </el-col>
      </el-row>
    </div>

    <el-dialog :title="$t('text.perfectInformation')" :visible.sync="perfectInformationDF" width="30%"
      :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false">
      <el-form ref="perfectInformationObjForm" :model="perfectInformationObj" label-width="80px">
        <el-form-item :label="$t('tenant.name')" prop="tenantName" :rules="[
      {
        required: true,
        message: $t('rules.required', [$t('tenant.name')]),
        trigger: 'blur',
      },
    ]">
          <el-input size="small" v-model.trim="perfectInformationObj.tenantName" />
        </el-form-item>
        <el-form-item :label="$t('user.name')" prop="userName" :rules="[
      {
        required: true,
        message: $t('rules.required', [$t('user.name')]),
        trigger: 'blur',
      },
    ]">
          <el-input size="small" v-model.trim="perfectInformationObj.userName" />
        </el-form-item>
        <el-form-item :label="$t('tenant.industry')" prop="industry" :rules="[
      {
        required: true,
        message: $t('rules.required', [$t('tenant.industry')]),
        trigger: 'blur',
      },
    ]">
          <el-input size="small" v-model.trim="perfectInformationObj.industry" />
        </el-form-item>
        <el-form-item :label="$t('tenant.province')" prop="province" :rules="[
      {
        required: true,
        message: $t('rules.required', [$t('tenant.province')]),
        trigger: 'blur',
      },
    ]">
          <el-input size="small" v-model.trim="perfectInformationObj.province" />
        </el-form-item>
        <el-form-item :label="$t('tenant.city')" prop="city" :rules="[
      {
        required: true,
        message: $t('rules.required', [$t('tenant.city')]),
        trigger: 'blur',
      },
    ]">
          <el-input size="small" v-model.trim="perfectInformationObj.city" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain :loading="perfectInformationDoing" size="small"
          @click="perfectInformationSubmit">{{ $t("text.submit") }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="sysNoticeDF" width="50%" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" :modal-append-to-body="false">
      <div class="center font20 red">{{ $t("menu.sysLogs") }}</div>
      <div>
        <raw-html :content="sysLog.content" type="richText" />
      </div>
      <!-- <div class="red">
        注意：因本次改动范围比较大，第一次登陆请清除浏览器缓存后重新登陆
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="default" plain size="small" @click="clickSystemUpdateClose">{{ $t("text.close") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import ls from "store2";
import Cookies from "js-cookie";
// import introJs from "intro.js";

import RawHtml from "@/components/RawHtml";

import UserSales from "./portals/UserSales";
import ShopSales from "./portals/ShopSales";
import WholeSales from "./portals/WholeSales";
import OrderThead from "./portals/OrderThead";
import OrderTrack from "./portals/OrderTrack";
import PurchaseSupplierSta from "./portals/PurchaseSupplierSta";
import PurchaseTrack from "./portals/PurchaseTrack";
import MaterialWH from "./portals/MaterialWH";
import MaterialOnWay from "./portals/MaterialOnWay";
import MesStatistic from "./portals/MesStatistic";
import MesTrack from "./portals/MesTrack";
import MesDispersion from "./portals/MesDispersion";
import MesProduce from "./portals/MesProduce";
import MesScanEnd from "./portals/MesScanEnd";
import Warehouse from "./portals/Warehouse";
import InventorySearch from "./portals/InventorySearch";
import Tasks from "./portals/Tasks";
import Message from "./portals/Message";
import MaterialSearch from "./portals/MaterialSearch";
import PromptFree from "./portals/PromptFree";
import DeliveryCount from "./portals/DeliveryCount";

import User from "@/api/user";
import SysLog from "@/api/sysLog";

export default {
  mixins: [page],
  data() {
    return {
      // 完善信息
      perfectInformationDF: false,
      perfectInformationObj: {
        userName: null,
        tenantName: null,
        industry: null,
        province: null,
        city: null,
      },
      perfectInformationDoing: false,
      //
      sysLog: { createAt: null },
      systemUpdateReadDF: false,
      sysNoticeDF: false,

      activeName: "start",
      //
      scheduleAt: null,
    };
  },
  components: {
    RawHtml,
    UserSales,
    ShopSales,
    WholeSales,
    OrderThead,
    OrderTrack,
    PurchaseSupplierSta,
    PurchaseTrack,
    MaterialWH,
    MaterialOnWay,
    MesStatistic,
    MesTrack,
    MesDispersion,
    MesProduce,
    MesScanEnd,
    Warehouse,
    InventorySearch,
    Tasks,
    Message,
    MaterialSearch,
    PromptFree,
    DeliveryCount,
  },
  created() {
    const self = this;
    if (
      self.Permit.currentTenant().name == null &&
      self.Permit.currentUser().admin === true
    ) {
      self.perfectInformationDF = true;
    } else {
      self.perfectInformationDF = false;
    }
    if (self.Permit.currentUser().admin === true) {
      SysLog.findLast().then(function (res) {
        if (res.data.code == 200) {
          self.sysLog = res.data.entity;
          if (self.sysLog.createAt == Cookies.get("sysLogLastCreateAt")) {
            self.systemUpdateReadDF = true;
          } else {
            self.systemUpdateReadDF = false;
          }
          self.sysNoticeDF = !self.systemUpdateReadDF;
        } else {
          self.sysError();
        }
      });
    }
  },
  methods: {
    handleClick(tab, event) {
      // this.activeName = tab;
    },
    //=====
    clickReadSystemUpdate() {
      Cookies.set("sysLogLastCreateAt", this.sysLog.createAt);
      this.$router.push({
        name: "sysLogs",
      });
    },
    clickSystemUpdateClose() {
      this.sysNoticeDF = false;
      Cookies.set("sysLogLastCreateAt", this.sysLog.createAt);
    },

    // 完善信息
    perfectInformationSubmit() {
      const self = this;
      this.$refs.perfectInformationObjForm.validate((valid) => {
        if (valid) {
          self.perfectInformationDoing = true;
          User.updateInfo(
            self.Permit.currentUser().id,
            self.perfectInformationObj
          ).then(function (res) {
            if (res && res.status === 200) {
              self.perfectInformationDoing = false;
              self.perfectInformationDF = false;
              self.$message({
                message: self.$t("prompt.perfectInformationSuccess"),
                type: "success",
              });
              self.getUser();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getUser() {
      const self = this;
      User.findById(self.Permit.currentUser().id).then(function (res) {
        if (res.data.code === 200) {
          // self.user = res.data.entity;
          // self.tenant = res.data.entity.tenant;
          ls.session("TENANT", res.data.entity.tenant);
          ls.session("USER", res.data.entity);
          // store.dispatch("setTenant", res.data.entity.tenant);
          // store.dispatch("setUser", res.data.entity);
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style scoped></style>
